var _style, _defs, _rect, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _path, _polyline7, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 109.6 110.4",
    style: {
      enableBackground: "new 0 0 109.6 110.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:transparent;}\r\n\t.st1{fill:#4398D8;}\r\n\t.st2{fill:#409B56;}\r\n\t.st3{fill:#8FBB30;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.1,
    y: 0,
    width: 109.5,
    height: 110.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0,
    className: "st0",
    width: 109.5,
    height: 110.3
  })))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "76.1,48.9 57.1,59.7 57.1,52.5 76.1,41.7 76.1,48.9 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "76.1,63.3 57.1,74.2 57.1,66.9 76.1,56.1 76.1,63.3 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "38.1,20.1 38.1,27.3 57.1,38.1 57.1,30.9 38.1,20.1 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "38.1,41.7 57.1,52.5 57.1,45.3 38.1,34.5 38.1,41.7 "
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "50.8,77.8 31.7,66.9 38.1,63.3 57.1,74.2 50.8,77.8 "
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "19,74.2 38.1,85 44.4,81.4 25.4,70.5 19,74.2 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.1,90.2h1.5v-3l1.1-1.3l3,4.3h1.8l-3.8-5.4l3.4-4.3h-1.7l-3.2,3.9c-0.3,0.3-0.5,0.9-0.8,1.3c0-0.4,0.1-1,0.1-1.4v-3.8H83 L83.1,90.2"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    points: "75.1,90.2 81.5,90.2 81.5,88.8 76.6,88.8 76.6,86 80.7,86 80.7,84.7 76.6,84.7 76.6,81.8 81.3,81.8 81.3,80.5  75.1,80.5 75.1,90.2 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2,90.3c2.1,0,3.7-1.2,3.7-3.5v-6.3h-1.5v6.2c0,1.6-0.8,2.3-2.2,2.3c-1.4,0-2.2-0.7-2.2-2.3v-6.2h-1.5v6.3 C65.5,89.1,67.1,90.3,69.2,90.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9,90.3c1.8,0,3.2-1,3.2-2.7c0-1.6-0.9-2.3-2.5-3.1L61,84.2c-1-0.4-1.4-0.8-1.4-1.5s0.5-1.1,1.3-1.1s1.2,0.3,1.6,0.9 l1.2-0.7c-0.6-1-1.5-1.5-2.7-1.5c-1.6,0-2.7,1-2.7,2.5s0.9,2.2,2.3,2.8l0.6,0.3c1.1,0.5,1.6,0.8,1.6,1.7c0,0.8-0.7,1.3-1.7,1.3 c-1.2,0-1.8-0.6-2.2-1.4l-1.2,0.7C58,89.4,59.1,90.3,60.9,90.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuek);
export default __webpack_public_path__ + "static/media/suek.cc1859d5e34b67e078bafe1331541d1e.svg";
export { ForwardRef as ReactComponent };